import * as types from '../mutation-types'

const state = {
  visitedViews: [], // 已经访问过的页面标签
  cachedViews: []   // 缓存标签内容，暂时未实现功能
}

const mutations = {
  [types.ADD_VISITED_VIEW]: (state, view) => {
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push(Object.assign({}, view, {
      title: view.meta.name || 'no-name'
    }))
  },
  [types.DEL_VISITED_VIEW]: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
